import { render, staticRenderFns } from "./ImportShopProducts.vue?vue&type=template&id=2ab3ebb2&scoped=true&"
import script from "./ImportShopProducts.vue?vue&type=script&lang=js&"
export * from "./ImportShopProducts.vue?vue&type=script&lang=js&"
import style0 from "./ImportShopProducts.vue?vue&type=style&index=0&id=2ab3ebb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3ebb2",
  null
  
)

export default component.exports